<template>
    <div class="container" :class="{ 'mobile-open': mobileOpen }">
        <div v-if="$slots['default']" ref="slot-default"><slot name="default" /></div>
        <div class="container-menu" ref="container-menu" style="flex:1;">
            <el-menu 
                :collapse="collapse" 
                :default-active="sideIndex" 
                :text-color="TextColor" 
                :active-text-color="TextActiveColor" 
                :style="{'border-right-color': BackgroundColor,'height':sideHeigh}" 
                class="el-menu-vertical"
                :class="{ 'mobile-menu': isMobile }"
            >
                <template v-for="(item1, key1) in (this.$getter('menu') || [])">
                    <router-link  v-if="item1.children.length == 0" :key="key1" :to="fullPath(`${item1.component}`||'',`${item1.component||''}`)" @click.native="handleMobileItemClick">
                        <el-menu-item :index="`side-${key1}`" :class="{'menu-item-select':sideIndex == `side-${key1}`}" class="menu-item-defalt">
                            <i :class="item1.icon||'icon-business'" :style="{color:sideIndex == `side-${key1}` ? TextActiveColor : TextColor, fontSize: item1.fontSize || '18px'}" class="icon"/>
                            <span slot="title">{{ item1.name }}</span>
                        </el-menu-item>
                    </router-link>

                    <el-submenu v-else :key="key1" :index="`side-${key1}`">
                        <template slot="title">
                            <i :class="item1.icon || 'icon-business'" :style="{color:sideIndex == `side-${key1}` ? TextActiveColor : TextColor, fontSize: item1.fontSize || '18px'}" class="icon"/>
                            <span slot="title">{{ item1.name }}</span>
                        </template>

                        <span v-for="(item2, key2) in item1.children" :key="`${key1}-${key2}`">
                            <router-link v-if="item1.children.length > 0" :key="`${key1}-${key2}`" :to="fullPath(`${item1.component||''}-${item2.component||''}`,`${item2.component||''}`)" @click.native="handleMobileItemClick">
                                <el-menu-item :index="`side-${key1}-${key2}`" :class="{'menu-item-select': sideIndex == `side-${key1}-${key2}`}" class="menu-item-defalt">
                                    <i v-if="item2.icon" :class="item2.icon" :style="{color:sideIndex == `side-${key1}-${key2}` ? TextActiveColor : TextColor, fontSize: item1.fontSize || '18px'}" class="icon"/>
                                    <span slot="title">{{ item2.name }}</span>
                                </el-menu-item>
                            </router-link>

                            <el-submenu v-else :key="`${key1}-${key2}`" :index="`side-${key1}-${key2}`">
                                <template slot="title">
                                    <i v-if="item2.icon" :class="item2.icon" :style="{color:sideIndex == `side-${key1}-${key2}` ? TextActiveColor : TextColor, fontSize: item1.fontSize || '18px'}" class="icon"/>
                                    <span slot="title">{{ item2.name }}</span>
                                </template>
                                <span v-for="(item3, key3) in item2.children" :key="`${key1}-${key2}-${key3}`">
                                    <router-link :key="`${key1}-${key2}-${key3}`" :to="fullPath(`${item1.component||''}-${item2.component||''}-${item3.component||''}`,`${item3.component||''}`)" @click.native="handleMobileItemClick">
                                        <el-menu-item :index="`side-${key1}-${key2}-${key3}`" :class="{'menu-item-select': sideIndex == `side-${key1}-${key2}-${key3}`}" class="menu-item-defalt">
                                            <i v-if="item3.icon" :class="item3.icon" :style="{color:sideIndex == `side-${key1}-${key2}-${key3}` ? TextActiveColor : TextColor, fontSize: item1.fontSize || '18px'}" class="icon"/>
                                            <span slot="title">{{ item3.name }}</span>
                                        </el-menu-item>
                                    </router-link>
                                </span>
                            </el-submenu>
                        </span>
                    </el-submenu>
                </template>
            </el-menu>
			<div :style="{ 'background-color': BackgroundColor }" class="collapse">
				<div class="collapse-container" @click="handleCollapse">
					<i :class="collapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "sidebar",
    props: {
        TextColor: {type: String,default: "#595959"},
        TextActiveColor: {type: String,default: "#4073FA"},
        BackgroundColor: {type: String,default: "#fdfdfd"},
        mainRoute: {type: String,default: "/"},
    },
    data() {
        return {
            sideIndex: '',
            sideIndexCache: {},
            sideHeigh: '400px',
            collapse: false,
            isMobile: false,
            mobileOpen: false,
            windowWidth: 0
        };
    },
    mounted() {
		this.init();
        this.checkDeviceType();
        window.addEventListener('resize', this.handleResize);
        
        // 初始化时立即设置当前路由高亮
        this.$nextTick(() => {
            this.resetSideIndexCache();
            this.updateSideIndexFromRoute();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods:{
		// 在 methods 中添加
		openMobileSidebar() {
		    if (this.isMobile) {
		        this.mobileOpen = true;
		    }
		},
		closeMobileSidebar() {
		    if (this.isMobile) {
		        this.mobileOpen = false;
		    }
		},
		toggleMobileSidebar() {
		    if (this.isMobile) {
		        this.mobileOpen = !this.mobileOpen;
		    }
		},
		init(){
			this.resetSideIndexCache();
			this.$nextTick().then(()=>{
			    if( this.$refs['slot-default'] && this.$refs['slot-default'].offsetHeight && this.$refs['container-menu'] && this.$refs['container-menu'].offsetHeight ){
			        this.sideHeigh = (this.$refs['container-menu'].offsetHeight-this.$refs['slot-default'].offsetHeight)+'px';
			    }else if( this.$refs['container-menu'] && this.$refs['container-menu'].offsetHeight ){
			        this.sideHeigh = this.$refs['container-menu'].offsetHeight+'px';
			    }
			});
		},
        fullPath(path,_path){
            path = path.replace(/(\-){2,}/g, "-")
            if(path.substr(0, 1) == "-"){
                path = path.substr(1);
            }
            if(_path.substr(0, 1) == "/"){
                path = _path;
            }
            return (`${this.mainRoute}/${path}`).replace(/(\/){2,}/g, "/");
        },
        resetSideIndexCache(){
            const menuItems = this.$getter('menu') || [];
            
            for( let key1 in menuItems ){
                const item1 = menuItems[key1];
                
                if( item1.component ){
                    const path1 = this.fullPath(`${item1.component}`, item1.component);
                    this.sideIndexCache[path1] = `side-${key1}`;
                }

                if( item1.children ){
                    for( let key2 in item1.children ){
                        const item2 = item1.children[key2];
                        
                        if( item2.component ){
                            const path2 = this.fullPath(`${item1.component||''}-${item2.component||''}`, `${item2.component||''}`);
                            this.sideIndexCache[path2] = `side-${key1}-${key2}`;
                        }

                        if( item2.children ){
                            for( let key3 in item2.children ){
                                const item3 = item2.children[key3];
                                
                                if( item3.component ){
                                    const path3 = this.fullPath(`${item1.component||''}-${item2.component||''}-${item3.component||''}`, `${item3.component||''}`);
                                    this.sideIndexCache[path3] = `side-${key1}-${key2}-${key3}`;
                                }
                            }
                        }
                    }
                }
            }
            
            // 更新当前路由的索引
            this.updateSideIndexFromRoute();
        },
        
        // 新增：从当前路由更新 sideIndex
        updateSideIndexFromRoute() {
            const currentPath = this.$route.path;
            
            // 直接匹配完整路径
            if (this.sideIndexCache[currentPath]) {
                this.sideIndex = this.sideIndexCache[currentPath];
                return;
            }
            
            // 尝试匹配去掉末尾斜杠的路径
            const pathWithoutSlash = currentPath.replace(/\/$/, '');
            if (pathWithoutSlash !== currentPath && this.sideIndexCache[pathWithoutSlash]) {
                this.sideIndex = this.sideIndexCache[pathWithoutSlash];
                return;
            }
            
            // 尝试匹配基础路径（去掉查询参数和哈希）
            const basePath = currentPath.split('?')[0].split('#')[0];
            if (basePath !== currentPath && this.sideIndexCache[basePath]) {
                this.sideIndex = this.sideIndexCache[basePath];
                return;
            }
            
            // 尝试路径包含匹配
            for (const [path, index] of Object.entries(this.sideIndexCache)) {
                if (currentPath.includes(path) || path.includes(currentPath)) {
                    this.sideIndex = index;
                    return;
                }
            }
            
            this.sideIndex = '';
        },
        
        handleCollapse() {
            this.collapse = !this.collapse;
            this.$emit('toggle-collapse', this.collapse);
            
            // 移动端点击折叠按钮时关闭侧边栏
            if (this.isMobile) {
                this.mobileOpen = false;
                this.$emit('mobile-close');
            }
        },
        handleMobileItemClick() {
            // 移动端点击菜单项时自动关闭侧边栏
            if (this.isMobile) {
                this.mobileOpen = false;
                this.$emit('mobile-close');
            }
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.checkDeviceType();
        },
        checkDeviceType() {
            const width = window.innerWidth;
            this.isMobile = width <= 768;
            
            // 移动端默认折叠
            if (this.isMobile) {
                this.collapse = false;
            }
        }
    },
    watch: {
        '$route.path'(newPath, oldPath) {
            this.updateSideIndexFromRoute();
        },
        isMobile(newVal) {
            // 设备类型变化时调整折叠状态
            if (newVal) {
                this.collapse = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
	.container {
		position: relative;
		height: 100%;
		display: flex;
		flex-direction: column;
		// background: linear-gradient(180deg, #f8faff 0%, #ffffff 100%);
		background-color: #fff;
		border-right: 1px solid rgba(64, 115, 250, 0.1);
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		
		// 移动端样式
		@media (max-width: 768px) {
			position: fixed;
			top: 0;
			left: 0;
			bottom: 0;
			width: 280px;
			transform: translateX(-100%);
			z-index: 1000;
			box-shadow: 2px 0 20px rgba(0, 0, 0, 0.15);
			border-right: none;
			
			&.mobile-open {
				transform: translateX(0);
			}
		}
		
		// 超小屏手机
		@media (max-width: 360px) {
			width: 260px;
		}

		.el-menu-vertical:not(.el-menu--collapse) {
			width: 240px;
			min-height: 400px;
			
			@media (max-width: 768px) {
				width: 100%;
			}
		}

		.el-menu-vertical {
			height: 100%;
			overflow: auto;
			padding-bottom: 60px;
			border: none;
			background: transparent;
			
			// 移动端菜单样式
			&.mobile-menu {
				padding-top: 10px;
				
				.menu-item-defalt,
				.el-submenu__title {
					margin: 4px 16px;
					border-radius: 10px;
					
					&:active {
						background: rgba(64, 115, 250, 0.1) !important;
						transform: scale(0.98);
					}
				}
			}
			
			// 菜单项基础样式
			.menu-item-defalt {
				height: 50px; /* 稍微减小高度 */
				line-height: 50px;
				margin: 4px 12px;
				border-radius: 8px;
				transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
				position: relative;
				overflow: hidden;
				
				&::before {
					content: '';
					position: absolute;
					left: 0;
					top: 50%;
					transform: translateY(-50%);
					width: 3px; /* 恢复原来的粗细 */
					height: 0;
					background: linear-gradient(180deg, #4073FA 0%, #5B8CFF 100%);
					border-radius: 0 2px 2px 0;
					transition: all 0.3s ease;
				}
				
				&:hover {
					background: rgba(64, 115, 250, 0.06) !important;
					transform: translateX(4px);
					// box-shadow: 0 2px 8px rgba(64, 115, 250, 0.15);
					
					&::before {
						height: 20px; /* 恢复原来的高度 */
					}
					
					.icon {
						color: #4073FA !important;
						transform: scale(1.1);
					}
				}
				
				.icon {
					margin-right: 12px; /* 恢复原来的间距 */
					font-size: 18px; /* 稍微减小图标 */
					transition: all 0.3s ease;
					position: relative;
					z-index: 1;
				}
				
				span {
					position: relative;
					z-index: 1;
					font-weight: 400; /* 变细一点，从500改为400 */
					transition: all 0.3s ease;
					font-size: 15px; /* 稍微减小文字大小 */
				}
			}

			// 选中状态
			.menu-item-select {
				background: linear-gradient(135deg, rgba(64, 115, 250, 0.12) 0%, rgba(64, 115, 250, 0.08) 100%) !important;
				// box-shadow: 0 2px 12px rgba(64, 115, 250, 0.2);
				transform: translateX(4px);
				
				&::before {
					height: 24px; /* 恢复原来的高度 */
					background: linear-gradient(180deg, #4073FA 0%, #5B8CFF 100%);
				}
				
				.icon {
					color: #4073FA !important;
					transform: scale(1.1); /* 稍微减小缩放 */
				}
				
				span {
					color: #4073FA !important;
					font-weight: 500; /* 变细一点，从600改为500 */
					text-shadow: 0 1px 1px rgba(64, 115, 250, 0.1); /* 减小阴影 */
				}
			}
			
			// 子菜单样式
			.el-submenu {
				.el-submenu__title {
					height: 50px; /* 稍微减小高度 */
					line-height: 50px;
					margin: 4px 12px;
					border-radius: 8px;
					transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
					position: relative;
					
					&::before {
						content: '';
						position: absolute;
						left: 0;
						top: 50%;
						transform: translateY(-50%);
						width: 3px; /* 恢复原来的粗细 */
						height: 0;
						background: linear-gradient(180deg, #4073FA 0%, #5B8CFF 100%);
						border-radius: 0 2px 2px 0;
						transition: all 0.3s ease;
					}
					
					&:hover {
						background: rgba(64, 115, 250, 0.06) !important;
						transform: translateX(4px);
						box-shadow: 0 2px 8px rgba(64, 115, 250, 0.15);
						
						&::before {
							height: 20px; /* 恢复原来的高度 */
						}
						
						.icon {
							color: #4073FA !important;
							transform: scale(1.1);
						}
					}
					
					.icon {
						margin-right: 12px; /* 恢复原来的间距 */
						font-size: 18px; /* 稍微减小图标 */
						transition: all 0.3s ease;
					}
					
					.el-submenu__icon-arrow {
						transition: all 0.3s ease;
						margin-top: -4px;
						font-size: 14px; /* 稍微减小箭头 */
					}
					
					span {
						font-size: 15px; /* 稍微减小文字大小 */
						font-weight: 400; /* 变细一点，从500改为400 */
					}
				}
				
				// 子菜单激活状态
				&.is-opened {
					.el-submenu__title {
						background: rgba(64, 115, 250, 0.08);
						
						&::before {
							height: 24px; /* 恢复原来的高度 */
						}
						
						.icon, span {
							color: #4073FA !important;
						}
						
						.el-submenu__icon-arrow {
							transform: rotate(180deg);
						}
					}
				}
				
				// 子菜单项缩进
				.el-menu-item {
					padding-left: 56px !important;
					min-width: auto;
					
					&.menu-item-defalt {
						margin: 2px 8px;
						border-radius: 6px;
						
						.icon {
							font-size: 16px; /* 稍微减小图标 */
							margin-right: 10px;
						}
						
						span {
							font-size: 14px; /* 稍微减小文字大小 */
							font-weight: 400; /* 保持400 */
						}
					}
				}
				
				// 三级菜单项
				.el-menu--inline .el-menu-item {
					padding-left: 72px !important;
					
					&.menu-item-defalt {
						margin: 1px 6px;
						border-radius: 4px;
						
						.icon {
							font-size: 14px; /* 稍微减小图标 */
							margin-right: 8px;
						}
						
						span {
							font-size: 13px; /* 稍微减小文字大小 */
							font-weight: 400; /* 保持400 */
						}
					}
				}
			}
			
			// 折叠状态样式
			&.el-menu--collapse {
				.menu-item-defalt,
				.el-submenu__title {
					margin: 4px 8px;
					
					&:hover {
						transform: translateX(2px);
					}
				}
				
				.menu-item-select {
					transform: translateX(2px);
				}
				
				// 移动端折叠状态
				@media (max-width: 768px) {
					width: 64px;
				}
			}
		}
	}

	// 折叠按钮样式
	.collapse {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 60px;
		border-top: 1px solid rgba(64, 115, 250, 0.08);
		background: rgba(248, 250, 255, 0.9) !important;
		backdrop-filter: blur(10px);
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 0 16px;
		z-index: 100;
		
		// 移动端样式
		@media (max-width: 768px) {
			height: 56px;
			padding: 0 12px;
			background: rgba(248, 250, 255, 0.95) !important;
		}

		.collapse-container {
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
			padding: 8px;
			border-radius: 8px;
			
			&:hover {
				background: rgba(64, 115, 250, 0.1);
				
				i {
					background: linear-gradient(135deg, #4073FA 0%, #5B8CFF 100%);
					color: white;
					transform: scale(1.1) rotate(180deg);
					box-shadow: 0 4px 12px rgba(64, 115, 250, 0.3);
				}
			}
			
			// 移动端触摸优化
			@media (max-width: 768px) {
				padding: 10px;
				min-height: 44px;
				min-width: 44px;
				
				&:active {
					background: rgba(64, 115, 250, 0.15);
					transform: scale(0.95);
				}
			}
			
			i {
				font-size: 18px; /* 稍微减小折叠图标 */
				height: 32px; /* 恢复原来的高度 */
				width: 32px; /* 恢复原来的宽度 */
				display: flex;
				justify-content: center;
				align-items: center;
				background: linear-gradient(135deg, #f0f2f5 0%, #e8ecf1 100%);
				border-radius: 6px;
				color: #666;
				transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
				box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
				border: 1px solid rgba(255, 255, 255, 0.5);
				
				// 移动端图标大小调整
				@media (max-width: 768px) {
					font-size: 20px; /* 稍微减小 */
					height: 36px; /* 稍微减小 */
					width: 36px; /* 稍微减小 */
				}
			}
		}
	}

	// 滚动条样式
	.el-menu-vertical::-webkit-scrollbar {
		width: 6px;
		
		// 移动端滚动条更细
		@media (max-width: 768px) {
			width: 4px;
		}
	}

	.el-menu-vertical::-webkit-scrollbar-track {
		background: rgba(64, 115, 250, 0.04);
		border-radius: 3px;
	}

	.el-menu-vertical::-webkit-scrollbar-thumb {
		background: rgba(64, 115, 250, 0.2);
		border-radius: 3px;
		transition: all 0.3s ease;
	}

	.el-menu-vertical::-webkit-scrollbar-thumb:hover {
		background: rgba(64, 115, 250, 0.4);
	}

	// 路由链接样式
	a {
		text-decoration: none;
		display: block;
		
		&:focus {
			outline: none;
		}
		
		// 移动端触摸优化
		@media (max-width: 768px) {
			-webkit-tap-highlight-color: transparent;
		}
	}

	// 响应式设计
	@media (max-width: 768px) {
		.container {
			.el-menu-vertical:not(.el-menu--collapse) {
				width: 100%;
			}
			
			// 移动端横屏优化
			@media (max-height: 500px) and (orientation: landscape) {
				.collapse {
					height: 48px;
					padding: 0 8px;
				}
				
				.el-menu-vertical {
					padding-bottom: 48px;
				}
			}
		}
	}

	// 平板设备优化
	@media (min-width: 769px) and (max-width: 1024px) {
		.container {
			.el-menu-vertical:not(.el-menu--collapse) {
				width: 220px;
			}
			
			.menu-item-defalt,
			.el-submenu__title {
				margin: 4px 10px;
				
				span {
					font-size: 14px; /* 平板设备文字大小 */
					font-weight: 400; /* 保持400 */
				}
				
				.icon {
					font-size: 16px; /* 平板设备图标大小 */
					margin-right: 10px;
				}
			}
		}
	}

	// 超小屏手机优化
	@media (max-width: 360px) {
		.container {
			width: 260px;
			
			.el-menu-vertical {
				.menu-item-defalt,
				.el-submenu__title {
					margin: 4px 8px;
					height: 46px; /* 稍微减小高度 */
					line-height: 46px;
					
					span {
						font-size: 14px; /* 超小屏文字大小 */
						font-weight: 400; /* 保持400 */
					}
					
					.icon {
						font-size: 16px; /* 超小屏图标大小 */
						margin-right: 10px;
					}
				}
			}
			
			.collapse {
				height: 52px;
				padding: 0 10px;
			}
		}
	}

	// 横屏模式优化
	@media (max-width: 768px) and (orientation: landscape) {
		.container {
			width: 240px;
			
			.el-menu-vertical {
				padding-bottom: 50px;
				
				.menu-item-defalt,
				.el-submenu__title {
					height: 44px;
					line-height: 44px;
					margin: 2px 12px;
				}
			}
		}
	}

	// 深色模式支持
	@media (prefers-color-scheme: dark) {
		.container {
			background: linear-gradient(180deg, #1e1e1e 0%, #2d2d2d 100%);
			border-right-color: rgba(255, 255, 255, 0.1);
		}
		
		.collapse {
			background: rgba(30, 30, 30, 0.9) !important;
			border-top-color: rgba(255, 255, 255, 0.1);
			
			.collapse-container i {
				background: linear-gradient(135deg, #2d2d2d 0%, #3d3d3d 100%);
				color: #ccc;
				border-color: rgba(255, 255, 255, 0.1);
			}
		}
	}
</style>